import { axiosInstancePlano } from "../../../../core/api/planoAxios";
import { IScheduleManagement } from "../../model/scheduleManagement";

export const getSchedule = async (userId: string): Promise<string> => {
  const { data } = await axiosInstancePlano.get(`/cronograma/user/${userId}/ultimo`);

  return data;
};

export const getDayContent = async (cronogramaId: string, date: string): Promise<IScheduleManagement> => {
  try {
    const { data } = await axiosInstancePlano.get(`/management/cronograma-info/${cronogramaId}?date=${date}`);

    return data;
  } catch (error: any) {
    throw error.response.data;
  }
};

export const deleteSchedule = async (cronogramaId: string) => {
  try {
    const { data } = await axiosInstancePlano.delete(`/cronograma/deletar-cronograma/${cronogramaId}`);
    return data;
  } catch (error: any) {
    throw error.response.data;
  }
};